/*
* This reusable hook copies children to the clipboard
*/
import { useState, useCallback, useEffect } from 'react';

export const useCopyToClipboard = () => {
    const [ isCopied, setIsCopied ] = useState(false);

    // Copy
    const copy = useCallback(async (text) => {
        if (!navigator?.clipboard) {
            console.warn('Clipboard not supported');
            return false;
        }

        try {
            await navigator.clipboard.writeText(text);
            setIsCopied(true);
            return true;

        } catch (error) {
            console.warn('Copy failed', error);
            setIsCopied(false);
            return false;
        }
    }, []);

    // Effect to reset the isCopied state after a delay
    useEffect(() => {
        if (isCopied) {
            const timer = setTimeout(() => {
                setIsCopied(false);
            }, 1000);

            // Cleanup - clear the timeout if the component unmounts
            return () => clearTimeout(timer);
        }
    }, [isCopied]);

    return [ isCopied, copy ];
}